import React, {Component} from 'react';
import {Input} from "reactstrap";

export class SwitchFilter extends Component {
    render() {
        return (
            <label className={'toggl-filter ' + this.props.type}>
                <Input type="checkbox" onChange={this.props.onChange} checked={this.props.checked} name={this.props.name}/>
                <div className="slider"><p className="filter-label">{this.props.label}<span>x</span></p></div>
            </label>
        )
    }
}

